/**
 * İlçe sınırları GeoJSON'unu (~22 MB) tek sefer yükleyip bellekte tutar.
 *
 * Önceden bu dosya her `filters.city` değişiminde yeniden `fetch` + `JSON.parse`
 * ediliyordu. Sunucu bu statik dosyayı `no-store` ile gönderdiği için tarayıcı
 * HTTP cache'i de devreye girmiyor ve her şehir seçiminde 22 MB yeniden iniyordu.
 *
 * Modül seviyesinde promise'i memoize ederek sayfa oturumu boyunca en fazla bir
 * kez indirme/parse garantisi verir. Tüm şehirlerin ilçeleri tek dosyada olduğu
 * için bir kez yüklemek her şehir için yeterlidir.
 */
let districtBoundsPromise: Promise<any> | null = null;

export function loadDistrictBounds(): Promise<any> {
	if (!districtBoundsPromise) {
		districtBoundsPromise = fetch('/simplified_ilce_sinirlari.json')
			.then((response) => {
				if (!response.ok) {
					throw new Error(`İlçe sınırları getirilemedi: HTTP ${response.status}`);
				}
				return response.json();
			})
			.catch((error) => {
				// Hata olursa bir sonraki denemede yeniden fetch edilebilsin diye sıfırla.
				districtBoundsPromise = null;
				throw error;
			});
	}
	return districtBoundsPromise;
}
